export default "__VITE_ASSET__DD6MoCRn__"